var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessoriesMobil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.18 24.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "My Accessories mobil") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 2,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 2,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    width: 2,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9,27.1a5,5,0,1,0,5,5A5,5,0,0,0,32.9,27.1Zm3,5.27a.38.38,0,0,1-.38.38h-2v2a.38.38,0,0,1-.38.38h-.38a.38.38,0,0,1-.38-.38v-2h-2a.38.38,0,0,1-.38-.38v-.32a.38.38,0,0,1,.38-.38h2v-2a.38.38,0,0,1,.38-.38h.38a.38.38,0,0,1,.38.38v2h2a.38.38,0,0,1,.38.38Z",
    transform: "translate(-11 -17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.26,24.48,38,23.17V17H36v7.38Z",
    transform: "translate(-11 -17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.45,34.18l.14-.4,2.59-.39V30.9l-2.59-.39-.14-.43A6.63,6.63,0,0,0,39,28.92l-.2-.39.25-.36c.16-.22.4-.53.73-.94l.55-.72a19,19,0,0,0-1.81-1.84l-2.07,1.56L36,26A7.52,7.52,0,0,0,35,25.59l-.42-.14-.4-2.61h-2.5c-.07.35-.18,1-.31,2.15l-.06.46-.44.14a7.6,7.6,0,0,0-1.07.45l-.41.21-2-1.59a8.63,8.63,0,0,0-.74.66,15.69,15.69,0,0,0-1.11,1.18q.81,1,1.32,1.71l.25.36-.21.39A6,6,0,0,0,26.37,30l-.13.44-2.61.39v2.48l2.6.38.13.45a5.19,5.19,0,0,0,.47,1.14l.22.4-.27.36c-.16.22-.4.54-.72.94l-.56.73a16.91,16.91,0,0,0,1.83,1.83L29.38,38l.4.21a8.21,8.21,0,0,0,1.07.44l.42.13.4,2.61h2.49c.08-.34.18-1,.32-2.15l.06-.45.43-.15A6.85,6.85,0,0,0,36,38.2l.41-.22,2,1.6a6,6,0,0,0,.74-.66,14.22,14.22,0,0,0,1.12-1.19c-.59-.73-1-1.29-1.32-1.72l-.25-.36.21-.39A7.76,7.76,0,0,0,39.45,34.18ZM32.9,37a4.92,4.92,0,1,1,4.92-4.91A4.92,4.92,0,0,1,32.9,37Z",
    transform: "translate(-11 -17)",
    fill: "#b4ccdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9,36.73a4.61,4.61,0,1,1,4.61-4.61A4.62,4.62,0,0,1,32.9,36.73Zm0-8.29a3.68,3.68,0,1,0,3.68,3.68A3.69,3.69,0,0,0,32.9,28.44Z",
    transform: "translate(-11 -17)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.9,28.71a3.38,3.38,0,0,0-.9.13V29h2v-.1A3.34,3.34,0,0,0,32.9,28.71Z",
    transform: "translate(-11 -17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    width: 2,
    height: 4.34,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.53,24.49l.36-.16c0-.28.08-.53.11-.77V17H28v6.3Z",
    transform: "translate(-11 -17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.28,28.69c-.27-.36-.6-.78-1-1.24l-.3-.37V29h1.14C25.19,28.9,25.23,28.79,25.28,28.69Z",
    transform: "translate(-11 -17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.29,25.57a15.27,15.27,0,0,1,1.23-1.32q.26-.26.48-.45V17H24v8.93Z",
    transform: "translate(-11 -17)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.33,38.67l-.72-.9.68-.93.6-.77.4-.51a5.32,5.32,0,0,1-.21-.5l-2.95-.43V33H11v6H24.61Z",
    transform: "translate(-11 -17)",
    fill: "#b4ccdd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessoriesMobil);
export default __webpack_public_path__ + "static/media/accessories-mobil.a63f0bb246fac98a289bceb23d6ca0b8.svg";
export { ForwardRef as ReactComponent };